import SeatSelectionBlock from './SeatSelectionBlock';
import { SeatSelectionBlockProps, SeatSelectionBlockValueProps } from './types';

export type { SeatSelectionBlockProps, SeatSelectionBlockValueProps };
export default SeatSelectionBlock;
